(function () {
  var cache = new Map();
  var pageSize = 6;

  function loadReviews(source) {
    if (!source) return Promise.reject(new Error('Lipsește sursa recenziilor.'));
    if (!cache.has(source)) {
      cache.set(source, fetch(source, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Recenziile nu au putut fi încărcate.');
        return response.json();
      }));
    }
    return cache.get(source);
  }

  function formatRating(value) {
    return Number(value || 0).toLocaleString('ro-RO', {
      minimumFractionDigits: 1,
      maximumFractionDigits: 2
    });
  }

  function setStarMeter(element, rating) {
    if (!element) return;
    element.style.setProperty('--ebfr-rating', Math.max(0, Math.min(100, (Number(rating) / 5) * 100)) + '%');
  }

  function hydrateSummary(element) {
    if (!element || element.dataset.reviewHydrated === 'true') return;
    element.dataset.reviewHydrated = 'true';
    loadReviews(element.dataset.reviewSource).then(function (payload) {
      var summary = payload.summary || {};
      var rating = Number(summary.average || 0);
      var total = Number(summary.total_reviews || 0);
      setStarMeter(element.querySelector('[data-eb-review-stars]'), rating);
      var text = element.querySelector('[data-eb-review-summary-text]');
      if (text) text.textContent = formatRating(rating) + ' (' + total + ')';
      element.setAttribute('aria-label', formatRating(rating) + ' din 5, ' + total + ' recenzii');
      element.setAttribute('aria-busy', 'false');
    }).catch(function () {
      var text = element.querySelector('[data-eb-review-summary-text]');
      if (text) text.textContent = 'Recenzii indisponibile momentan';
      element.classList.add('is-error');
      element.setAttribute('aria-busy', 'false');
      element.dataset.reviewHydrated = 'false';
    });
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  }

  function renderDistribution(summary) {
    var distribution = createElement('div', 'ebfr-distribution');
    var rated = Number(summary.rated_reviews || 0);
    for (var star = 5; star >= 1; star -= 1) {
      var count = Number((summary.distribution || {})[String(star)] || 0);
      var row = createElement('div', 'ebfr-distribution__row');
      row.appendChild(createElement('span', '', star + ' stele'));
      var track = createElement('span', 'ebfr-distribution__track');
      var fill = createElement('i', 'ebfr-distribution__fill');
      fill.style.width = (rated ? count / rated * 100 : 0) + '%';
      track.appendChild(fill);
      row.appendChild(track);
      row.appendChild(createElement('strong', '', String(count)));
      distribution.appendChild(row);
    }
    if (Number(summary.unrated_reviews || 0) > 0) {
      var note = createElement('p', 'ebfr-distribution__note', summary.unrated_reviews + ' recenzii fără rating, păstrate din sistemul vechi.');
      distribution.appendChild(note);
    }
    return distribution;
  }

  function renderReview(review) {
    var article = createElement('article', 'ebfr-review');
    var head = createElement('div', 'ebfr-review__head');
    var identity = createElement('div', 'ebfr-review__identity');
    identity.appendChild(createElement('strong', '', review.reviewer || 'Client EB Prime'));
    if (review.verified) identity.appendChild(createElement('span', 'ebfr-review__verified', 'Achiziție verificată'));
    head.appendChild(identity);

    var rating = Number(review.rating || 0);
    if (rating > 0) {
      var stars = createElement('span', 'ebfr-star-meter ebfr-review__stars', '★★★★★');
      stars.setAttribute('aria-label', formatRating(rating) + ' din 5 stele');
      setStarMeter(stars, rating);
      head.appendChild(stars);
    } else {
      head.appendChild(createElement('span', 'ebfr-review__unrated', 'Fără rating'));
    }
    article.appendChild(head);

    article.appendChild(createElement('p', 'ebfr-review__text', review.content || ''));
    var meta = createElement('div', 'ebfr-review__meta');
    if (review.date) {
      var date = new Date(review.date);
      meta.appendChild(createElement('time', '', new Intl.DateTimeFormat('ro-RO', { day: '2-digit', month: 'long', year: 'numeric' }).format(date)));
    }
    if (review.origin && review.origin.product_name) {
      meta.appendChild(createElement('span', '', 'Produs cumpărat: ' + review.origin.product_name));
    }
    article.appendChild(meta);

    if (Array.isArray(review.images) && review.images.length) {
      var gallery = createElement('div', 'ebfr-review__images');
      review.images.forEach(function (source) {
        var image = document.createElement('img');
        image.src = source;
        image.alt = 'Imagine adăugată de ' + (review.reviewer || 'client');
        image.loading = 'lazy';
        image.decoding = 'async';
        gallery.appendChild(image);
      });
      article.appendChild(gallery);
    }

    if (review.company_response) {
      var response = createElement('div', 'ebfr-review__response');
      response.appendChild(createElement('strong', '', 'Răspuns EB Prime'));
      response.appendChild(createElement('p', '', review.company_response));
      article.appendChild(response);
    }
    return article;
  }

  function renderPanel(panel, payload) {
    var content = panel.querySelector('[data-eb-review-content]');
    if (!content) return;
    content.textContent = '';

    var summary = payload.summary || {};
    var overview = createElement('div', 'ebfr-overview');
    var score = createElement('div', 'ebfr-overview__score');
    score.appendChild(createElement('strong', '', formatRating(summary.average)));
    var stars = createElement('span', 'ebfr-star-meter ebfr-overview__stars', '★★★★★');
    stars.setAttribute('aria-label', formatRating(summary.average) + ' din 5 stele');
    setStarMeter(stars, summary.average);
    score.appendChild(stars);
    score.appendChild(createElement('span', '', summary.total_reviews + ' recenzii reale'));
    overview.appendChild(score);
    overview.appendChild(renderDistribution(summary));
    content.appendChild(overview);

    var list = createElement('div', 'ebfr-list');
    list.setAttribute('data-eb-review-list', '');
    content.appendChild(list);
    var reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
    var visible = 0;

    function appendBatch() {
      reviews.slice(visible, visible + pageSize).forEach(function (review) {
        list.appendChild(renderReview(review));
      });
      visible = Math.min(visible + pageSize, reviews.length);
      if (button) {
        button.hidden = visible >= reviews.length;
        button.textContent = 'Vezi mai multe recenzii (' + (reviews.length - visible) + ')';
      }
    }

    var button = null;
    if (reviews.length > pageSize) {
      button = createElement('button', 'ebfr-load-more', 'Vezi mai multe recenzii');
      button.type = 'button';
      button.addEventListener('click', appendBatch);
      content.appendChild(button);
    }
    appendBatch();
    panel.setAttribute('aria-busy', 'false');
  }

  function hydratePanel(panel) {
    if (!panel || panel.dataset.reviewHydrated === 'true') return;
    panel.dataset.reviewHydrated = 'true';
    loadReviews(panel.dataset.reviewSource).then(function (payload) {
      renderPanel(panel, payload);
    }).catch(function () {
      var content = panel.querySelector('[data-eb-review-content]');
      if (content) content.innerHTML = '<p class="ebfr-panel__error" role="alert">Recenziile nu pot fi încărcate momentan. Te rugăm să reîncerci.</p>';
      panel.setAttribute('aria-busy', 'false');
      panel.dataset.reviewHydrated = 'false';
    });
  }

  function hydrate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('[data-eb-review-summary]').forEach(hydrateSummary);
    scope.querySelectorAll('[data-eb-review-panel]').forEach(hydratePanel);
    if (scope.matches && scope.matches('[data-eb-review-summary]')) hydrateSummary(scope);
    if (scope.matches && scope.matches('[data-eb-review-panel]')) hydratePanel(scope);
  }

  window.EBPrimeReviews = { hydrate: hydrate, load: loadReviews };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { hydrate(document); });
  else hydrate(document);
  document.addEventListener('shopify:section:load', function (event) { hydrate(event.target); });
})();
